import React, { useState } from 'react'
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

interface ISkillsSection {
  skills: string[],
  setSkills: (skills: string[]) => void
}

function SkillsSection({ skills, setSkills }: ISkillsSection) {
  const [ currentSkill, setCurrentSkill ] = useState<string>("");
  const addSkill = () => {
    if (currentSkill.trim() && !skills.includes(currentSkill)) {
      setSkills([...skills, currentSkill.trim()]);
      setCurrentSkill("");
    }
  };

  return (
    <section className="space-y-4 p-3 bg-white 
      border-2 border-gray-200 rounded-xl">
      <h2 className="text-xl text-indigo-600 font-medium">Skills</h2>
      <div className="flex gap-2">
        <Input placeholder="Enter a skill (e.g. Next.js)" value={currentSkill} onChange={(e) => setCurrentSkill(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && addSkill()} />
        <Button onClick={addSkill} type="button">Add Skill</Button>
      </div>
      <div className="min-h-16 border rounded-md p-4 bg-slate-50 flex flex-wrap gap-2">
        {skills.length === 0 && <span className="text-muted-foreground italic text-sm">No skills added yet...</span>}
        {skills.map((skill) => (
          <div key={skill} 
              className="bg-indigo-500 text-primary-foreground 
                  px-3 py-2
                  rounded-md text-sm flex items-center gap-2">
            {skill}
            <button 
              onClick={() => setSkills(skills.filter(s => s !== skill))}>
                  <Trash2 size={12} />
              </button>
          </div>
        ))}
      </div>
    </section>
  )
}

export default SkillsSection